import * as THREE from 'three'
import { useEffect } from 'react'
import { useThree } from '@react-three/fiber'
import { suspend, preload, clear } from 'suspend-react'

export function useVideoTexture(src, props) {
  const { unsuspend, start, crossOrigin, muted, loop } = {
    unsuspend: 'canplay', // canplay - canplaythrough
    crossOrigin: 'Anonymous',
    muted: true,
    loop: true,
    start: true,
    ...props,
  }
  const gl = useThree((state) => state.gl)
  const texture = suspend(
    () =>
      new Promise((res, rej) => {
        const video = Object.assign(document.createElement('video'), {
          src,
          crossOrigin,
          loop,
          muted,
        })
        const texture = new THREE.VideoTexture(video)
        texture.encoding = gl.outputEncoding
        video.addEventListener(unsuspend, () => res(texture))
      }),
    [src]
  )

  useEffect(() => {
      if(start)
        texture.image.play()
  }, [texture]);
  
  return texture
}
